import { Component, Input, OnInit } from '@angular/core';
import { UiServices } from 'src/app/services/ui-services';
import { ObservationsComponent } from '../observations/observations.component';

@Component({
  selector: 'app-consumed-services',
  templateUrl: './consumed-services.component.html',
  styleUrls: ['./consumed-services.component.scss'],
})
export class ConsumedServicesComponent implements OnInit {
  @Input() services: any[] = [];

  constructor(private uiSv: UiServices) {}

  ngOnInit() {}

  async openObservation(observation) {
    await this.uiSv.showModal(
      ObservationsComponent,
      { observation },
      'observation-modal'
    );
  }
}
